import type { AccountingCategoryWithChildren } from '@cpce/shared';

export function buildCategoryNameMap(
  categories: AccountingCategoryWithChildren[]
): Map<number, string> {
  const map = new Map<number, string>();
  for (const cat of categories) {
    map.set(cat.id, cat.name);
    for (const child of cat.children) {
      map.set(child.id, child.name);
    }
  }
  return map;
}
